import { render } from "./UsersFavouritesPage.vue?vue&type=template&id=06184b20&scoped=true"
import script from "./UsersFavouritesPage.vue?vue&type=script&lang=js"
export * from "./UsersFavouritesPage.vue?vue&type=script&lang=js"

import "./UsersFavouritesPage.vue?vue&type=style&index=0&id=06184b20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06184b20"]])

export default __exports__